import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { unstable_batchedUpdates } from 'react-dom'
import validationCheckTrue from '../../assets/images/validationCheckTrue.svg'
import validationCheckFalse from '../../assets/images/validationCheckFalse.svg'
import WORDING from '../../constants/wording'

export default function InputValidationList({ setDisabled }) {
  const [isEmpty, setIsEmpty] = useState(true)
  const [isRange, setIsRange] = useState(true)
  const [isHasEne, setIsHasEne] = useState(true)
  const [isSpecialChars, setIsSpecialChars] = useState(true)

  const {
    watch,
    formState: { errors }
  } = useFormContext()

  const watchAllFields = watch()

  const showValidation = (valName) =>
    errors?.xxlField?.message.includes(valName)

  const {
    ALIAS_MSG_CHARACTER_AMOUNT,
    ALIAS_MSG_HAS_ENIE,
    ALIAS_MSG_SPECIAL_CHARACTERS
  } = WORDING

  useEffect(() => {
    let range = false
    let hasEne = false
    let specialChars = false
    let empty = false
    let isDisabled = false

    if (showValidation('range')) {
      range = true
      isDisabled = true
    }

    if (showValidation('hasEne')) {
      hasEne = true
      isDisabled = true
    }

    if (showValidation('specialChars')) {
      specialChars = true
      isDisabled = true
    }

    if (watchAllFields?.xxlField?.length === 0) {
      empty = true
      isDisabled = true
    }

    unstable_batchedUpdates(() => {
      setIsRange(range)
      setIsEmpty(empty)
      setIsHasEne(hasEne)
      setIsSpecialChars(specialChars)
      setDisabled(isDisabled)
    })
  }, [watchAllFields])

  return (
    <div className='w-full my-2.5'>
      <ul>
        <li className='flex items-center py-0.5'>
          <img
            className='mr-1.5'
            src={
              isRange || isEmpty ? validationCheckFalse : validationCheckTrue
            }
            alt=''
          />
          <span className='text-black text-2xs'>
            {ALIAS_MSG_CHARACTER_AMOUNT}
          </span>
        </li>
        <li className='flex items-center py-0.5'>
          <img
            className='mr-1.5'
            src={
              isHasEne || isEmpty ? validationCheckFalse : validationCheckTrue
            }
            alt=''
          />
          <span className='text-black text-2xs'>{ALIAS_MSG_HAS_ENIE}</span>
        </li>
        <li className='flex items-center py-0.5'>
          <img
            className='mr-1.5'
            src={
              isSpecialChars || isEmpty
                ? validationCheckFalse
                : validationCheckTrue
            }
            alt=''
          />
          <span className='text-black text-2xs'>
            {ALIAS_MSG_SPECIAL_CHARACTERS}
          </span>
        </li>
      </ul>
    </div>
  )
}
